module.exports = __webpack_public_path__ + "img/Edit-Icon.20608df1.svg";